/**
 * 素材账号表请求接口
 * @author 王振宇
 * @since 2024-01-01
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MATERIAL_ACCOUNT_PAGE_LIST: function GET_MATERIAL_ACCOUNT_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/materialAccount/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MATERIAL_ACCOUNT_LIST: function GET_MATERIAL_ACCOUNT_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/materialAccount/getList',
        method: 'get',
        params: data
      });
    },
    SAVE_MATERIAL_ACCOUNT: function SAVE_MATERIAL_ACCOUNT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/materialAccount/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MATERIAL_ACCOUNT: function UPDATE_MATERIAL_ACCOUNT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/materialAccount/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MATERIAL_ACCOUNT: function DELETE_MATERIAL_ACCOUNT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/materialAccount/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MATERIAL_ACCOUNT: function DELETE_BATCH_MATERIAL_ACCOUNT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/materialAccount/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});